(function(){
  /* Galerie : piste à glisser (mobile) + vignettes / points synchronisés */
  document.querySelectorAll('[data-sl-gal]').forEach(function(gal){
    var track=gal.querySelector('[data-gal-track]'); if(!track) return;
    var slides=gal.querySelectorAll('[data-gal-slide]'),thumbs=gal.querySelectorAll('[data-gal-thumb]'),dots=gal.querySelectorAll('[data-gal-dot]'),count=gal.querySelector('[data-gal-count]');
    var prev=gal.querySelector('[data-gal-prev]'),next=gal.querySelector('[data-gal-next]');
    var cur=0,n=slides.length,timer;
    function mark(i){
      cur=i;
      if(prev) prev.disabled=(i===0); if(next) next.disabled=(i===n-1);
      thumbs.forEach(function(t,k){t.classList.toggle('on',k===i)});
      dots.forEach(function(d,k){d.classList.toggle('on',k===i)});
      if(count) count.textContent=(i+1)+' / '+n;
    }
    function go(i,smooth){
      i=Math.max(0,Math.min(n-1,i));
      track.scrollTo({left:i*track.clientWidth,behavior:smooth===false?'auto':'smooth'});
      mark(i);
    }
    thumbs.forEach(function(t,k){t.addEventListener('click',function(){go(k)})});
    dots.forEach(function(d,k){d.addEventListener('click',function(){go(k)})});
    if(prev) prev.addEventListener('click',function(){go(cur-1)}); if(next) next.addEventListener('click',function(){go(cur+1)});
    track.addEventListener('scroll',function(){
      clearTimeout(timer);
      timer=setTimeout(function(){var i=Math.round(track.scrollLeft/track.clientWidth); if(i!==cur) mark(i)},60);
    },{passive:true});
    window.addEventListener('resize',function(){go(cur,false)});
  });

  document.querySelectorAll('[data-sl-buy]').forEach(function(root){
    var price=root.querySelector('[data-bb-price]'),was=root.querySelector('[data-bb-was]'),badge=root.querySelector('[data-bb-badge]'),cta=root.querySelector('[data-bb-cta]');
    if(!price) return;
    function apply(o){
      root.querySelectorAll('.sl-opt').forEach(function(x){x.classList.remove('on')}); o.classList.add('on');
      var u=o.getAttribute('data-unit'); price.innerHTML=o.getAttribute('data-price')+(u?'<small>'+u+'</small>':'');
      was.textContent=o.getAttribute('data-was')||''; badge.textContent=o.getAttribute('data-badge')||'';
      var c=o.getAttribute('data-cta'); if(c) cta.innerHTML=c; var h=o.getAttribute('data-href'); if(h) cta.setAttribute('href',h);
    }
    var opts=root.querySelectorAll('.sl-opt:not(.sl-opt--off)');
    opts.forEach(function(o){o.addEventListener('click',function(){apply(o)});o.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();apply(o)}});});
    var init=root.querySelector('.sl-opt.on')||opts[0]; if(init) apply(init);
  });
})();
